<div class="interaction-selector">
    <mat-button-toggle-group
        [appearance]="'standard'"
        [hideSingleSelectionIndicator]="true"
        [value]="selectedInteractionTable"
        (change)="onInteractionTableChange($event)">
        <mat-button-toggle value="database">Database</mat-button-toggle>
        <mat-button-toggle value="processing">Processing</mat-button-toggle>
        <mat-button-toggle value="salesforce">Salesforce</mat-button-toggle>
    </mat-button-toggle-group>
</div>
@if (selectedInteractionTable === 'database') {
    <div class="interaction-table-container">
        @if (!interactionErrorTableData()?.databaseErrorTableData) {
            <div class="no-data-view">Loading...</div>
        } @else if (databaseInteractionDataSource.data.length === 0) {
            <div class="no-data-view">No database errors to show</div>
        } @else {
            <table
                class="interaction-table"
                mat-table
                [dataSource]="databaseInteractionDataSource"
                matSort
                #databaseSort="matSort">
                <ng-container matColumnDef="numErroredRecords">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="numErroredRecords">Errored Records</th>
                    <td mat-cell *matCellDef="let interaction">
                        {{ interaction.numErroredRecords }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
                    <td mat-cell *matCellDef="let interaction">{{ interaction.status }}</td>
                </ng-container>
                <ng-container matColumnDef="query">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="query">Query</th>
                    <td mat-cell *matCellDef="let interaction">{{ interaction.query }}</td>
                </ng-container>
                <ng-container matColumnDef="rawException">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="rawException">Raw Exception</th>
                    <td mat-cell *matCellDef="let interaction">
                        {{ interaction.rawException }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="databaseColumnsToDisplay"></tr>
                <tr mat-row *matRowDef="let row; columns: databaseColumnsToDisplay"></tr>
            </table>
            <mat-paginator
                #databasePaginator
                [length]="databaseInteractionDataSource.data.length"
                [pageSize]="interactionPageSize"
                [pageSizeOptions]="[10, 25, 50]"
                showFirstLastButtons />
        }
    </div>
}
@if (selectedInteractionTable === 'processing') {
    <div class="interaction-table-container">
        @if (!interactionErrorTableData()?.processingErrorTableData) {
            <div class="no-data-view">Loading...</div>
        } @else if (processingErrorDataSource.data.length === 0) {
            <div class="no-data-view">No processing errors to show</div>
        } @else {
            <table
                class="interaction-table"
                mat-table
                [dataSource]="processingErrorDataSource"
                matSort
                #processingSort="matSort">
                <ng-container matColumnDef="numErroredRecords">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="numErroredRecords">Errored Records</th>
                    <td mat-cell *matCellDef="let error">
                        {{ error.numErroredRecords }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="rawException">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="rawException">Raw Exception</th>
                    <td mat-cell *matCellDef="let error">
                        {{ error.rawException }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="processingErrorColumnsToDisplay"></tr>
                <tr mat-row *matRowDef="let row; columns: processingErrorColumnsToDisplay"></tr>
            </table>
            <mat-paginator
                #processingPaginator
                [length]="processingErrorDataSource.data.length"
                [pageSize]="interactionPageSize"
                [pageSizeOptions]="[10, 25, 50]"
                showFirstLastButtons />
        }
    </div>
}
@if (selectedInteractionTable === 'salesforce') {
    <div class="interaction-table-container">
        @if (!interactionErrorTableData()?.salesforceErrorTableData) {
            <div class="no-data-view">Loading...</div>
        } @else if (salesforceInteractionDataSource.data.length === 0) {
            <div class="no-data-view">No Salesforce errors to show</div>
        } @else {
            <table
                class="interaction-table"
                mat-table
                [dataSource]="salesforceInteractionDataSource"
                matSort
                #salesforceSort="matSort">
                <ng-container matColumnDef="numErroredRecords">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="numErroredRecords">Errored Records</th>
                    <td mat-cell *matCellDef="let interaction">
                        {{ interaction.numErroredRecords }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="statusCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="statusCode">Status Code</th>
                    <td mat-cell *matCellDef="let interaction">
                        {{ interaction.statusCode }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="rawException">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="rawException">Raw Exception</th>
                    <td mat-cell *matCellDef="let interaction">
                        {{ interaction.rawException }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="salesforceColumnsToDisplay"></tr>
                <tr mat-row *matRowDef="let row; columns: salesforceColumnsToDisplay"></tr>
            </table>
            <mat-paginator
                #salesforcePaginator
                [length]="salesforceInteractionDataSource.data.length"
                [pageSize]="interactionPageSize"
                [pageSizeOptions]="[10, 25, 50]"
                showFirstLastButtons />
        }
    </div>
}
